export default __webpack_public_path__ + "images/Tea.a18cdc.jpg";